export default __webpack_public_path__ + "static/media/how-to-create-account.3f87c95b.svg";